<div class="flex items-center gap-2">
  @if (hasValue() && twoStage()) {
    <app-attribute-fulfillment-two-stage
      [capabilityLevel]="capabilityLevel()"
      [provisioningType]="provisioningType()"
      [singleStageScore]="singleStageScore()"
      [disabled]="effectiveDisabled()"
      [readonly]="readonly()"
      [testIdKey]="testIdKey()"
      (valueChange)="onTwoStageChange($event)"
    />
  } @else if (hasValue()) {
    @switch (attribute().fulfillmentType) {
      @case (FulfillmentType.TERNARY) {
        <app-attribute-fulfillment-ternary
          [score]="effectiveScore()"
          [disabled]="effectiveDisabled()"
          [testIdKey]="testIdKey()"
          (valueChange)="onScoreChange($event)"
        />
      }
      @case (FulfillmentType.BOOLEAN) {
        <app-attribute-fulfillment-boolean
          [score]="effectiveScore()"
          [disabled]="effectiveDisabled()"
          [testIdKey]="testIdKey()"
          (valueChange)="onScoreChange($event)"
        />
      }
      @case (FulfillmentType.NUMERIC) {
        <app-attribute-fulfillment-numeric
          [score]="effectiveScore()"
          [disabled]="effectiveDisabled()"
          [testIdKey]="testIdKey()"
          (valueChange)="onScoreChange($event)"
        />
      }
      @case (FulfillmentType.PERCENTAGE) {
        <app-attribute-fulfillment-percentage
          [score]="effectiveScore()"
          [disabled]="effectiveDisabled()"
          [testIdKey]="testIdKey()"
          (valueChange)="onScoreChange($event)"
        />
      }
    }
  } @else {
    <div class="w-40">
      <app-model-field-text
        [id]="'attribute-score-absent-' + testIdKey()"
        [value]="'common.noValue' | transloco"
        [isReadOnly]="true"
      />
    </div>
  }

  <app-model-field-button
    [icon]="hasValue() ? 'pi pi-check-circle' : 'pi pi-times-circle'"
    [active]="hasValue()"
    [disabled]="disabled()"
    [id]="'attribute-no-value-' + testIdKey()"
    tooltipKey="provider.tenderResponse.subcriteriaAttributes.scoreAbsent"
    (clicked)="toggleValue()"
  />
</div>
